import { useHistory } from "react-router-dom";
import { KioskBackButton } from "src/components/kiosk/KioskBackButton";
import { Timer } from "src/components/kiosk/Timer";
import Container from "src/components/layout/Container";
import { useStore } from "src/stores/Store";
import { useSearchParams } from "src/utils/useSearchParams";

interface Props {}

export default function KioskSuccess(props: Props) {
  const store = useStore();
  const history = useHistory();
  const params = useSearchParams();

  return (
    <Container className="py-4">
      <div className="mb-8 flex items-center">
        <div className="flex-1"></div>
        <KioskBackButton />
      </div>

      <div className="mb-4 text-center">
        <div
          className="mx-auto flex h-24 w-24 animate-scaleIn items-center justify-center rounded-full text-6xl text-white sm:h-16 sm:w-16 sm:text-4xl"
          style={{
            background: store.theme.orgColor,
          }}
        >
          <i className="far fa-check mt-1" />
        </div>
      </div>

      <div className="mx-auto max-w-md text-center">
        <h1 className="mb-2 text-7xl font-bold text-organization sm:text-3xl">
          Welcome, {params.get("user")}!
        </h1>
        <p className="mb-8 text-2xl sm:text-lg">You are checked in.</p>

        <Timer
          onEnd={() => {
            history.push("/kiosk");
          }}
          time={5 * 1000}
        />
      </div>
    </Container>
  );
}
